import { Check } from 'lucide-react'

type Props = { props: Record<string, string | number | boolean> }

export function FeatureListPreview({ props: p }: Props) {
  const features = [p.feature1, p.feature2, p.feature3].filter(Boolean) as string[]
  const iconColor = (p.iconColor as string) || '#22c55e'

  return (
    <ul className="space-y-2 py-2">
      {features.map((feature, i) => (
        <li key={i} className="flex items-center gap-2">
          <Check className="w-4 h-4 flex-shrink-0" style={{ color: iconColor }} />
          <span className="text-sm text-tf-text-sub">{feature}</span>
        </li>
      ))}
    </ul>
  )
}
